import { SCError, VoiceErrorType } from "@next-platform/packages-ts-types";
import { useTranslation } from "../../localization/hooks";
const { ERROR_CODE_PREFIX } = SCError || {};
// eslint-disable-next-line id-length -- matches useTranslation().t; literal t("error:voice.…") keys for grep / i18n extractors
function getNonContextVoiceErrors(t) {
    return {
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.VOICE_UPLOAD_FAILED}`]: t("error:voice.uploadFailed"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.VOICE_DELETION_FAILED}`]: t("error:voice.deletionFailed"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.VOICE_DELETE_ALL_FAILED}`]: t("error:voice.deleteAllFailed"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.VOICE_NOT_FOUND}`]: t("error:voice.notFound"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.VOICE_DELETION_FAILED_FROM_S3}`]: t("error:voice.deletionFailedFromS3"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.VOICE_DELETE_ALL_FAILED_FROM_S3}`]: t("error:voice.deleteAllFailedFromS3"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.VOICE_CREATION_FAILED}`]: t("error:voice.creationFailed"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.INVALID_FILE_TYPE}`]: t("error:voice.invalidFileType"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.VOICE_GET_SIGNED_URL_FAILED}`]: t("error:voice.getSignedUrlFailed"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.VOICE_ID_REQUIRED}`]: t("error:voice.idRequired"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.VOICE_ALREADY_GENERATED}`]: t("error:voice.alreadyGenerated"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.RATE_VOICE_INVALID_INPUT}`]: t("error:voice.rateVoiceInvalidInput"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.RATE_AUDIO_ERROR}`]: t("error:voice.rateAudioError"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.UPDATE_VOICE_ERROR}`]: t("error:voice.updateError"),
        [`${ERROR_CODE_PREFIX}-${VoiceErrorType.VOICE_FETCH_FAILED}`]: t("error:voice.fetchFailed"),
    };
}
// eslint-disable-next-line import/prefer-default-export -- named hook export matches package barrel
export function useVoiceErrors() {
    const { t } = useTranslation();
    const nonContextVoiceErrors = getNonContextVoiceErrors(t);
    const getMessage = ({ errorCode, fallbackMessage, skipDefaultMessage }) => {
        const nonContextError = nonContextVoiceErrors[errorCode];
        if (nonContextError) {
            return nonContextError;
        }
        if (skipDefaultMessage)
            return "";
        return fallbackMessage || t("error:fallbackError");
    };
    return {
        getMessage,
    };
}
